"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _loader = _interopRequireDefault(require("./loader"));
var _default = _loader["default"];
exports["default"] = _default;